import { gql, TypedDocumentNode } from "@apollo/client";

import { Space, SearchSpacesInput } from "types/generated";

export const GET_SPACES_BY_ACTION: TypedDocumentNode<{ spaces: Space[] }, { input: SearchSpacesInput }> =
  gql`
    query GetSpacesByAction($input: SearchSpacesInput!) {
      spaces(input: $input) {
        id
        name
        description
        parentSpace
        inheritEntities
        accessLevel
        labels
      }
    }
  `;
